import { AttachmentModel } from "./document.model";

export interface INewsResponse {
  items: INews[];
  nextUrl: string | null;
  previousUrl: string | null;
  maxItems: number;
  totalCount: number;
  currentUrl?: string;
}

export interface INews {
  id: string;
  entityId: string;
  title: string;
  headline: string;
  summary: string;
  isUrgent: boolean;
  application: string;
  mailRecipients: string;
  targetCompetition: string;
  createdBy: string;
  createdById: string;
  lastUpdatedBy: string;
  lastUpdatedById: string;
  lastUpdatedDate: string;
  contentDate: string;
  parts: IParts[];
  published: boolean;
  status: string;
  selfUrl: string;
  _thumbnail?: string | null;
}

export interface IParts {
  type: PartType;
  externalType?: string;
  content?: any;
  image?: PartImage | null;
  file?: {
    originalFileName: string;
    downloadUrl: string;
  };
  document?: AttachmentModel;
}

export interface PartImage {
  downloadUrl: string;
  id: string;
  previewUrl: string;
  thumbnailUrl: string;
  title?: string;
}

export enum PartType {
  Markdown = "markdown",
  Photo = "photo",
  External = "external",
  Document = "document",
}

export enum NewsOperationType {
  Post = "post",
  Put = "put",
}


export interface NewsEditModalFieldsLabels {
  title: string;
  thumbnail: string;
  application: string;
  mailRecipients: string;
  competition: string;
  uploadAttachments: string; 
  attachments: string;
}
export interface NewsEditModalFieldsPlaceholders {
  title: string;
  noThumbnail: string;
}

export interface NewsEditModalButtonsLabels {
  save: string;
  cancel: string;
  publish: string;
  unPublish: string;
  upload: string;
}
export interface NewsEditModalDropdownOptions {
  application: {
    all: string;
    booking: string;
    contentServices: string;
    interviews: string;
  };
  mailRecipients: {
    none: string;
    broadcasters: string;
  };
  competition: {
    all: string;
    firstLeague: string;
    secondLeague: string;
    championsLeague: string;
    playOffs: string;
  };
}
export interface NewsEditModalLabels {
  modalTitle: string;
  notificationSectionTitle: string;
  fieldsLabels: NewsEditModalFieldsLabels;
  fieldsPlaceholders: NewsEditModalFieldsPlaceholders;
  buttonsLabels: NewsEditModalButtonsLabels;
  dropdownOptions: NewsEditModalDropdownOptions;
}

export interface ISetEntityPublishedStatus {
  published: boolean;
  updatedBy: string;
  updatedById: string;
}